export default __webpack_public_path__ + "static/media/Bloodnail.cfdfcc92.jpg";